import {Controller} from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input";

export default class extends Controller {
  #errorMap = ["Numéro invalide", "Code pays invalide", "Trop court", "Trop long", "Numéro invalide", "Numéro invalide"];
  #iti;
  #input
  #inputName

  initialize() {
    this.#input = this.element
    this.onInput = this.onInput.bind(this)
    this.#inputName = this.#input.getAttribute("name")
    // Temporary modify name attribute so iti can initialize properly (it cannot add the hidden field if name is already used)
    this.#input.setAttribute("name", "iti_phone")
    this.loadScript();
    this.#input.setAttribute("name", `_${this.#inputName}`)
  }

  async loadScript() {
    this.#iti = intlTelInput(this.#input, {
      initialCountry: "fr",
      hiddenInput: (telInputName) => ({
        phone: this.#inputName,
      }),
      loadUtils: () => import("intl-tel-input/utils"),
    });
    this.element.addEventListener('input', this.onInput)
    this.element.addEventListener('change', this.onChange)
  };

  onInput() {
    this.reset();
    this.#iti.hiddenInput.value = this.#iti.getNumber()
    if (this.element.value.trim()) {
      if (this.#iti.isValidNumber()) {
      } else {
        const inputGroup = this.element.closest('.oq-input-group')
        if (inputGroup) {
          let errorNode = inputGroup.querySelector(".field-error")
          if (!errorNode) {
            errorNode = document.createElement('div')
            errorNode.classList.add('field-error')
          }
          var errorCode = this.#iti.getValidationError();
          errorNode.innerHTML = errorCode in this.#errorMap ? this.#errorMap[errorCode] : "Numéro invalide";
          inputGroup.appendChild(errorNode)
        }
      }
    }
  }

  reset() {
    this.element.classList.remove('is-danger')
    const errorNode = this.element.closest('.oq-input-group').querySelector(".field-error")
    if (errorNode)
      errorNode.remove()
  };

}
